import { Quote, PawPrint } from "lucide-react";
import SectionHead from "../SectionHead";
import { Reveal } from "../motion";
import { useLang } from "../../i18n";

const Testimonials = () => {
    const { t } = useLang();
    const items = t.testi.items || [];
    return (
        <section data-testid="testimonials-section" className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28">
            <SectionHead
                eyebrow={t.testi.eyebrow}
                title={t.testi.title}
                sub={t.testi.sub}
                testid="testimonials-title"
            />
            <div className="mt-12 grid gap-5 md:grid-cols-3">
                {items.map((item, i) => (
                    <Reveal key={item.author} delay={i * 0.1}>
                        <figure
                            data-testid={`testimonial-${i + 1}`}
                            className="flex h-full flex-col rounded-[1.5rem] border border-[#E3DCCF] bg-white p-7 shadow-sm transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-lg"
                        >
                            <Quote size={22} className="text-terracotta" aria-hidden="true" />
                            <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-[#525B53]">
                                {item.text}
                            </blockquote>
                            <figcaption className="mt-5 flex items-center gap-2.5 border-t border-[#E3DCCF] pt-4">
                                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-olive-light text-olive-dark">
                                    <PawPrint size={14} />
                                </span>
                                <span className="text-sm font-semibold text-ink">
                                    {item.author} <span className="font-normal text-[#7C877E]">{item.dog}</span>
                                </span>
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
                <Reveal delay={items.length * 0.1}>
                    <figure
                        data-testid="testimonial-pending"
                        className="flex h-full flex-col rounded-[1.5rem] border border-dashed border-[#C85A32]/40 bg-white/60 p-7"
                    >
                        <Quote size={22} className="text-terracotta/50" aria-hidden="true" />
                        <blockquote className="mt-4 flex-1 text-sm italic leading-relaxed text-[#7C877E]">
                            {t.testi.pending}
                        </blockquote>
                        <figcaption className="mt-5 flex items-center gap-2.5 border-t border-dashed border-[#E3DCCF] pt-4">
                            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-sand/70 text-[#7C877E]">
                                <PawPrint size={14} />
                            </span>
                            <span className="text-xs font-semibold text-[#7C877E]">{t.testi.eyebrow}</span>
                        </figcaption>
                    </figure>
                </Reveal>
            </div>
        </section>
    );
};

export default Testimonials;
